import React, { forwardRef } from "react";
import { PropTypes } from "prop-types";
import { useTheme, MenuItem } from "@material-ui/core";
import { FilledSelect } from "../FilledSelect";
import ClearItem from "./ClearItem";
import SelectedDisplayValue from "./SelectedDisplayValue";

const FirmwarePackageItem = forwardRef((props, ref) => {
  const { pkg, fleetDefault } = props;
  const theme = useTheme();

  if (!pkg) return null;

  const propsToPass = Object.keys(props).reduce((final, current) => {
    if (current !== "pkg" && current !== "fleetDefault") {
      final[current] = props[current];
    }
    return final;
  }, {});

  return (
    <MenuItem component="div" ref={ref} value={pkg?.url} {...propsToPass}>
      <ul style={{ listStyle: "none", paddingInlineStart: "0px" }}>
        <li>
          <SelectedDisplayValue
            showAsterisk={fleetDefault === pkg?.url}
            text={pkg?.version}
          />
          <ul style={{ listStyle: "none", paddingInlineStart: theme.spacing(2) }}>
            <li>{`SC: ${pkg.sc?.version}`}</li>
            <li>{`MD: ${pkg.md?.version}`}</li>
            <li>{`BMS: ${pkg?.bms?.version}`}</li>
          </ul>
        </li>
      </ul>
    </MenuItem>
  );
});

const ComponentFirmwarePropType = PropTypes.shape({
  version: PropTypes.string,
  id: PropTypes.string,
});

FirmwarePackageItem.propTypes = {
  pkg: PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string,
    version: PropTypes.string,
    sc: ComponentFirmwarePropType,
    md: ComponentFirmwarePropType,
    bms: ComponentFirmwarePropType,
  }).isRequired,
  fleetDefault: PropTypes.string,
};

FirmwarePackageItem.defaultProps = {
  fleetDefault: null,
};

const FirmwarePackageSelect = (props) => {
  const { fleetDefault, firmwarePackages } = props;

  return (
    <FilledSelect
        {...props}
        value={firmwarePackages && firmwarePackages.length ? props.value : ""}
    >
      {firmwarePackages && [
        <ClearItem key="clear" value="" />,
        ...firmwarePackages.map((pkg) => pkg ? (
            <FirmwarePackageItem
              pkg={pkg}
              fleetDefault={fleetDefault}
              key={pkg?.id}
              value={pkg?.url}
            >
              <SelectedDisplayValue
                showAsterisk={fleetDefault === pkg?.url}
                text={pkg?.version}
              />
            </FirmwarePackageItem>
          ) : null),
      ]}
    </FilledSelect>
  );
};

FirmwarePackageSelect.propTypes = {
  fleetDefault: PropTypes.string,
  firmwarePackages: PropTypes.array.isRequired,
  value: FilledSelect.propTypes.value,
};

FirmwarePackageSelect.defaultProps = {
  fleetDefault: null,
  value: FilledSelect.defaultProps.value,
};

export default FirmwarePackageSelect;
